import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { AbbreviationsPage } from "@/features/reference/components/abbreviations-page";

const search = z.object({ q: z.string().optional() });

/** The legacy "Arrival › Utility › Abbreviations" list, for logins holding help.view. */
export const Route = createFileRoute("/_app/abbreviations")({
  beforeLoad: () => {
    if (!useAuth.getState().can("help.view")) throw redirect({ to: "/" });
  },
  validateSearch: search,
  component: Page,
});

function Page() {
  const { q } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <AbbreviationsPage
      q={q ?? ""}
      onSearch={(next) =>
        void navigate({
          search: { q: next.trim() ? next : undefined },
          replace: true,
        })
      }
    />
  );
}
